import { HttpParams } from '@angular/common/http';
import { PageableParam } from '@rms/sdk/models';
import { createFilterParams, Filter } from '@rms/ui/filters';

export function pagedParams({ page, size, sort }: PageableParam, filters: Filter[]): HttpParams {
  const params = new HttpParams({ fromObject: sort?.length ? { page, size, sort } : { page, size } });

  return createFilterParams(filters, params);
}
